import { render, staticRenderFns } from "./StatisticProjectReportsBlankConfirmTableHeader.vue?vue&type=template&id=39bc24c2&"
import script from "./StatisticProjectReportsBlankConfirmTableHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsBlankConfirmTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports